export default __webpack_public_path__ + "static/media/trail_on.98300237.svg";